import { createReducer, on } from '@ngrx/store';
import { GetAllHomeMeasuresSuccess, GetNotificationSettingsSuccess, SetNotificationSettingsSuccess } from './homes.action';
import { initialHomesStateVelux } from './homes.state';

export const HomesVeluxReducers = createReducer(
  initialHomesStateVelux,

  on(GetNotificationSettingsSuccess, (state, { notificationSettings }) => {
    const homeIds = Object.keys(notificationSettings);
    let updateHomes = state.homes;
    for (const id of homeIds) {
      const notification = notificationSettings[id];
      updateHomes = state.homes.map(home => {
        if (home.id === id) {
          home.notification_settings = { ...notification['NXG'] };
        }
        return home;
      });
    }

    return {
      ...state,
      homes: updateHomes,
    };
  }),

  on(SetNotificationSettingsSuccess, (state, { notificationSettings, homeId }) => {
    const updateHomes = state.homes.map(home => {
      if (home.id === homeId) {
        home.notification_settings = { ...notificationSettings };
      }
      return home;
    });
    return {
      ...state,
      homes: updateHomes,
    };
  }),

  on(GetAllHomeMeasuresSuccess, (state, { measures, homeId }) => {
    const updateHomes = state.homes.map(home => {
      if (home.id === homeId) {
        home.measures = { ...measures };
      }
      return home;
    });
    return {
      ...state,
      homes: updateHomes,
    };
  }),
);
